import type { AiChatPresentation } from "@src/store/slices/global";

import type { AgenticLogicView } from "./ruleViewParams";

/**
 * Whether the Atlas chat takes the whole page or sits beside it as the rail.
 *
 * While Atlas designs a rule there is nothing for the page to show but a
 * skeleton, so the conversation is the page: the creation view once a build
 * starts, and the rule it produced until that rule has a graph to draw. The
 * first graph is what earns the split layout — the chart beside the chat that
 * explains it.
 *
 * Only the running build goes full page. Opening a rule — with a graph or
 * without one — is the split layout from the first frame, and so is every view
 * once the session ends: a build that finished without a graph leaves the
 * author on the workspace, where the rest of the rule is still reachable.
 */
export const resolveAtlasChatPresentation = ({
  view,
  isSessionActive,
  buildingRuleId,
  hasGraph,
}: {
  view: AgenticLogicView;
  isSessionActive: boolean;
  /** The rule the running session created, once its create tool ran. */
  buildingRuleId: string | null;
  /** Whether the rule on screen has a selection-logic graph to show. */
  hasGraph: boolean;
}): AiChatPresentation => {
  if (!isSessionActive) {
    return "rail";
  }
  if (view.kind === "new") {
    return "page";
  }
  if (view.kind === "rule" && view.ruleId === buildingRuleId && !hasGraph) {
    return "page";
  }
  return "rail";
};
